import moment from 'moment';
import 'moment/locale/ru';
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['service', 'clinic', 'price', 'serviceSelect', 'doctorSelect', 'calltouchable']
  static values = {
    category: Number,
    service: String,
    price: String,
    clinic: String,
    locale: String
    // doctorTag: String,
    // doctorFio: String
  }

  connect() {
  }

  serviceValueChanged() {
    this.showService()
  }

  priceValueChanged() {
    this.showPrice()
  }

  clinicValueChanged() {
    this.showClinic()
  }

  changeCategory(e) {
    this.categoryValue = e.target.value
    this.fetchServices().then(data => {
      this.serviceSelectTarget.select.setData(data.services)
      this.changeService()
    })
  }

  changeService() {
    const dataset = this.optionSelected(this.serviceSelectTarget).dataset

    this.serviceValue = dataset.opt
    this.priceValue = dataset.info
  }

  // changeDoctorTag(e){
  //   this.doctorTagValue = e.target.value
  //   this.fetchDoctors().then(data => {
  //     this.doctorSelectTarget.select.setData(data.doctors)
  //     this.changeDoctorFio()
  //   })
  // }

  // changeDoctorFio() {
  //   const dataset = this.optionSelected(this.doctorSelectTarget).dataset

  //   this.clinicTargets[0].value = dataset.clinic
  //   this.clinicTargets[1].textContent = dataset.address
  // }

  changeClinic(e) {
    this.clinicValue = this.optionSelected(e.target).dataset.address
  }

  showService() {
    this.serviceTarget.querySelectorAll('div')[0].textContent = this.serviceValue
  }

  showClinic() {
    this.clinicTarget.textContent = this.clinicValue
  }

  showPrice() {
    this.serviceTarget.querySelectorAll('div')[1].innerHTML = this.priceValue
    this.priceTarget.innerHTML = this.priceValue
  }

  fetchServices() {
    return fetch(`/services?category_id=${this.categoryValue}`, {
      headers: {
        accept: "application/json",
        'content-language': this.localeValue
      }
    }).then(response => response.json())
  }

  // fetchDoctors() {
  //   return fetch(`/order/doctors?tag=${this.doctorTagValue}`, {
  //     headers: {
  //       accept: "application/json"
  //     }
  //   }).then(response => response.json())
  // }

  optionSelected(select) {
    return select.options[select.selectedIndex]
  }

  checkCalltouch() {
    this.calltouchableTarget.value = window.Calltouch != undefined
  }
}
